

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

const ScrollNext = ({ to, className }) => {
    const navigate = useNavigate();
    return (
        <Link
            to={to}
            href={to}
            smooth={true}
            duration={500}
            className={`${className} cursor-pointer absolute bottom-8`}
            onClick={() => navigate(`#${to}`, { replace: true })}
        >
            <div className="absolute bottom-8">
                <div className="animate-bounce">
                    <span className="text-4xl">&darr;</span>
                </div>
            </div>
        </Link>

    );
};

export default ScrollNext;
